/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Postal_Code_PlaceholderInputs */

const en_orders_postal_code_placeholder = /** @type {(inputs: Orders_Postal_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postal code`)
};

const es_orders_postal_code_placeholder = /** @type {(inputs: Orders_Postal_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codigo postal`)
};

/**
* | output |
* | --- |
* | "Postal code" |
*
* @param {Orders_Postal_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_postal_code_placeholder = /** @type {((inputs?: Orders_Postal_Code_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Postal_Code_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_postal_code_placeholder(inputs)
	return es_orders_postal_code_placeholder(inputs)
});